import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "az_admin_token";
export const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` } });
export const errMsg = (e, fb) => (typeof e.response?.data?.detail === "string" ? e.response.data.detail : fb);
export const imgUrl = (u) => (u?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { dateStyle: "medium" }) : "—");
export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const STATUS_LABEL = {
    awaiting_payment: "Awaiting Payment", cod_received: "New · COD", paid: "New · Paid", confirmed: "Confirmed", processing: "Processing",
    packed: "Packed", shipped: "Shipped", out_for_delivery: "Out for Delivery", delivered: "Delivered", cancelled: "Cancelled", returned: "Returned",
};
export const STATUS_TONE = {
    awaiting_payment: "bg-cream text-ash border border-gold/30", cod_received: "bg-charcoal text-goldlight", paid: "bg-gold text-ivory",
    confirmed: "bg-[#4A5A2A] text-ivory", processing: "bg-[#6B5B2A] text-ivory", packed: "bg-[#7A5230] text-ivory", shipped: "bg-[#2F4858] text-ivory",
    out_for_delivery: "bg-[#1F5F7A] text-ivory", delivered: "bg-[#3E5F3A] text-ivory", cancelled: "bg-[#8B2E2E] text-ivory", returned: "bg-[#5A3A5A] text-ivory",
};
export const PAY_LABEL = { pending: "Pending", paid: "Paid", cod: "COD", failed: "Failed", refunded: "Refunded" };
export const PAY_TONE = { pending: "text-ash", paid: "text-[#3E5F3A]", cod: "text-golddark", failed: "text-[#8B2E2E]", refunded: "text-[#5A3A5A]" };

export const api = {
    get: (p, params) => axios.get(`${API}${p}`, { ...auth(), params }).then((r) => r.data),
    post: (p, body) => axios.post(`${API}${p}`, body, auth()).then((r) => r.data),
    patch: (p, body) => axios.patch(`${API}${p}`, body, auth()).then((r) => r.data),
};

export const waLink = (o) => {
    const digits = o.phone.replace(/\D/g, "");
    const num = digits.length === 10 ? `91${digits}` : digits;
    const items = o.items.map((i) => `${i.qty} × ${i.name}`).join(", ");
    const ref = o.id.slice(0, 8).toUpperCase();
    const track = `https://www.alzahraperfumery.com/track`;
    const msg = o.shipment?.awb_code
        ? `Hello ${o.name.split(" ")[0]}, your Al Zahra Perfumery order #${ref} (${items}) has shipped via ${o.shipment.courier}. Tracking no. ${o.shipment.awb_code} — track here: ${o.shipment.tracking_url} or at ${track}`
        : `Hello ${o.name.split(" ")[0]}, this is Al Zahra Perfumery. Your order #${ref} (${items}) — total ₹${o.total} — is confirmed. Track it anytime at ${track}`;
    return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
};

export const Badge = ({ status, testId }) => (
    <span className={`text-[9px] tracking-[0.2em] uppercase px-2 py-1 whitespace-nowrap ${STATUS_TONE[status] ?? "bg-cream text-ash"}`} data-testid={testId}>{STATUS_LABEL[status] ?? status}</span>
);

export const Stat = ({ label, value, sub, testId }) => (
    <div className="border border-gold/25 bg-cream/40 p-5" data-testid={testId}>
        <p className="text-[10px] tracking-[0.25em] uppercase text-ash mb-2">{label}</p>
        <p className="font-serif text-3xl text-charcoal">{value}</p>
        {sub && <p className="text-[11px] text-smoke mt-1">{sub}</p>}
    </div>
);

export const Select = ({ value, onChange, options, testId, className = "" }) => (
    <select data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)} className={`bg-transparent border border-gold/40 text-xs text-charcoal px-3 py-2.5 outline-none focus:border-gold ${className}`}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
);

export const Btn = ({ children, onClick, testId, tone = "ghost", disabled, href }) => {
    const cls = {
        ghost: "border border-gold/40 text-golddark hover:bg-gold hover:text-ivory",
        dark: "bg-charcoal text-goldlight hover:bg-golddark hover:text-ivory",
        outline: "border border-charcoal/50 text-charcoal hover:bg-charcoal hover:text-goldlight",
        danger: "border border-[#8B2E2E]/50 text-[#8B2E2E] hover:bg-[#8B2E2E] hover:text-ivory",
    }[tone];
    const base = `inline-flex items-center justify-center gap-2 px-4 py-2.5 text-[10px] tracking-[0.2em] uppercase transition-colors duration-300 disabled:opacity-50 ${cls}`;
    if (href) return <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId} className={base}>{children}</a>;
    return <button type="button" onClick={onClick} disabled={disabled} data-testid={testId} className={base}>{children}</button>;
};
